import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { getProgressFromControl } from "../utilities/ProgressHelper";
import { NavbarIcon } from "./navbar/Icon";

export const CustomCircularProgress = ({
  progress,
}: {
  progress: { completed: number; total: number };
}) => {
  const value = progress ? getProgressFromControl(progress) : 0;
  const theme = useTheme();
  return (
    <Box sx={{ gap: "5px", display: "flex", alignItems: "center" }}>
      {progress.total === 0 ? (
        <NavbarIcon
          variant="not-started"
          sx={{
            width: "20px",
            height: "20px",
          }}
        />
      ) : value === 100 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            backgroundColor: theme.palette.custom.greenTypography,
          }}
        >
          <NavbarIcon
            variant="tick"
            sx={{
              width: "10px",
              height: "10px",
            }}
          />
        </Box>
      ) : (
        <Box position="relative" display="inline-flex">
          {/* Background (not completed part) */}
          <CircularProgress
            variant="determinate"
            value={100}
            size={20}
            sx={{
              color: theme.palette.custom.secondaryBorder, // Gray background color
            }}
          />
          {/* Foreground (completed part) */}
          <CircularProgress
            variant="determinate"
            value={value}
            size={20}
            color="success"
            sx={{
              position: "absolute", // Overlap the background
              left: 0,
            }}
          />
        </Box>
      )}
      <Typography variant="body2">
        {progress?.completed} of {progress?.total}
      </Typography>
    </Box>
  );
};
